import { Box, styled } from "@material-ui/core";
import React from "react";
import { Button } from "../../Inputs";
const StyledA = styled("a")({
    textDecoration: "none"
});
export const ReadMoreLink = ({ link, linkText, readMoreText, date }) => {
    return (React.createElement(Box, { display: "flex", width: 1, marginTop: 2, marginBottom: 2 },
        React.createElement(Box, { width: 1 / 2, display: "flex", justifyContent: "flex-start", alignItems: "center" },
            React.createElement("a", { href: link }, linkText || link)),
        React.createElement(Box, { width: 1 / 2, display: "flex", justifyContent: "flex-end", alignItems: "center" },
            date &&
                React.createElement(Box, { style: { paddingRight: 30 } },
                    React.createElement("span", null, date)),
            React.createElement(StyledA, { href: link },
                React.createElement(Button, null, readMoreText || "Läs")))));
};
export default ReadMoreLink;
//# sourceMappingURL=ReadMoreLink.js.map